// extracted by mini-css-extract-plugin
module.exports = {"root":"SetPasswdForm_root__1Bv50","label":"SetPasswdForm_label__3gHgm"};